"use client"
import styled from "styled-components";
import Image from "next/image";
import ErrorFlyIcon from "@/images/icon/error-fly-icon.png";
import { EXPOSURE_RECORD } from '@/tracks/27786'
import { useTranslation } from '@/i18n/client'
type Props = {
  className?: string
  errorMessage?: string
  onEmit?: () => void
}

const ErrorTryAgainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 12px;
  }
  .show-message {
    color: rgba(194, 196, 204, 1);
    font-size: 14px;
    margin-bottom: 12px;
  }
  .btn {
    padding: 6px 12px;
    color: rgba(26, 26, 26, 1);
    border-radius: 4px;
    border: 1px solid rgba(136, 139, 148, 1);
    cursor: pointer;
    z-index: 66;
    font-size: 12px;
  }
`
export const ErrorTryAgain = ({ className, errorMessage, onEmit }: Props) => {
  const { t } = useTranslation()
  const onClick = () => {
    onEmit && onEmit()
    window.location.reload()
  }
  return <ErrorTryAgainWrapper
    className={className}>
    <Image src={ErrorFlyIcon} width={120} height={120} alt="error" />
    <p
      exptag={"exp|" + EXPOSURE_RECORD.Error_Page_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
      className="show-message"
    >{errorMessage || t('common.message.networkError')}</p>
    <div className="btn" onClick={onClick}>{t('common.btnText.tryAgain')}</div>
  </ErrorTryAgainWrapper>
}